import HttpClient from "./http-client";

export interface IBackupInfo {
  id?: string;
  db_connection_id: string;
  db_tool_id: string;
  compress_file_format_id: string;
  connections?: {
    id: string,
    connection_name: string,
    connection_description: string,
    host_name: string,
    user_name: string,
    port: string
  };
  database_name: string;
  storage_type?: string;
  backup_name?: string;
  bucket_name?: string;
  bucket_prefix?: string;
  backup_type_id?: string;
  type_of_operation?: string;
  things_to_backup_id?: string;
  retention?: number;
  actions?: string;
}

export default class BackupAPIServices {
  public static async createBackup(payload: IBackupInfo) {
    try {
      const { data } = await HttpClient.post(`db/backup/`, payload);
      // console.log(data);
      if (data.status !== undefined)
        return {"status": data.status, "backup_id": data.backup_id, "message": data.message};
      
      return data.data;
    } catch (error) {
      console.log(error);
    }
  }

  public static async getBackupList() {
    const { data } = await HttpClient.get(`db/backup/`);
    return data.data;
  }

  public static async getBackupDetailsById(payload: {backup_id: string}) {
    try {
      const { data } = await HttpClient.post(`db/backup/get_a_backup/`, payload);
      return data.data;
    } catch (error) {
      console.log(error);
    }
  }

  public static async runOnDemandBackUp(payload: {id: string}) {
    try {
      const { data } = await HttpClient.post(`db/backup/immediate_backup/`, payload);
      // console.log(data);
      if (data.status !== undefined)
        return {"status": data.status, "message": data.message};
      
      return data.data;
    } catch (error) {
      console.log(error);
    }
  }

}
